import React from 'react'
import './Hero.css'
// import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// import { Link } from 'react-scroll';

const Hero = () => {
  return (
    <div className='hero container'>
       <div className="hero-text">
            <h1>வணக்கம்</h1>
            
        </div>

    </div>
  )
}

export default Hero